/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m31 24.5654c.553 0 1 .448 1 1s-.447 1-1 1h-30c-.553 0-1-.448-1-1s.447-1 1-1h.305v-5.522c0-.552.447-1 1-1h3.913c.553 0 1 .448 1 1v5.522h1.913v-12.043c0-.553.447-1 1-1h3.913c.553 0 1 .447 1 1v12.043h1.912v-9.435c0-.552.447-1 1-1h3.913c.553 0 1 .448 1 1v9.435h1.913v-18.565c0-.553.447-1 1-1h3.913c.553 0 1 .447 1 1v18.565zm-27.695 0h1.913v-4.522h-1.913zm7.826 0h1.913v-11.043h-1.913zm7.825 0h1.913v-8.435h-1.913zm7.826 0h1.913v-17.565h-1.913z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;